commons.factory('loadExternalDataService', function(http, $window, API_BASE_URL) {


    const current_tag = 'https://raw.githubusercontent.com/ProzorroUKR/standards/refs/heads/master/'

    const proxyUrl = 'proxy_doc_download/?doc_url=';
    const getCriteriasResource = current_tag +'criteria/article_17.json';
    const getOtherCriteriasResource = current_tag +'criteria/other.json';
    const getGuaranteeCriteriasResource = current_tag +'criteria/tender_guarantee.json';
    const getContractGuaranteeCriteriasResource = current_tag +'criteria/contract_guarantee.json';
    const getLccCriteriasResource = current_tag +'criteria/LCC.json';
    const classifierObjections16 = current_tag +'criteria/article_16.json';
    const violation_amcu = current_tag +'AMCU/violation_amcu.json';
    const amcu = current_tag +'AMCU/amcu.json';
    const amcu_24 = current_tag +'AMCU/amcu_24.json';
    const requested_remedies_type = current_tag +'AMCU/requested_remedies_type.json';
    const local_origin_level = current_tag +'criteria/local_origin_level.json';
    const reporting_cause = current_tag +'codelists/tender/tender_cause_details/reporting.json';
    const negotiation_quick_cause = current_tag +'codelists/tender/tender_cause_details/negotiation.quick.json';
    const negotiation_cause = current_tag +'codelists/tender/tender_cause_details/negotiation.json';
    const uPlanList = current_tag +'classifiers/plan_of_ukraine.json';
    const funderProgramsList = 'https://prozorroukr.github.io/standards/codelists/plans/funder_program.json';
    const uFacility = current_tag +'criteria/ukraine_facility.json';
    const contract_change_922 = current_tag +'codelists/contract_change_rationale_type_law_922.json';
    const contract_change_1178 = current_tag +'codelists/contract_change_rationale_type_decree_1178.json';
    const getEdrpouResource = `${API_BASE_URL}/companies/edrpou/`;


    function createLoadFunc(url, storageName) {
        return function() {
            const cache = $window.localStorage.getItem(storageName);
            const timeStamp = Number(localStorage.getItem(storageName + 'TimeStamp'));
            return new Promise((resolve, reject) => {
                if (cache && (timeStamp + 60 * 60 * 1000) > Date.now()) {
                    // console.log('loadExternalDataService', storageName, 'cache', cache);
                    resolve(JSON.parse(cache));
                } else {
                    http.get(proxyUrl + encodeURIComponent(url) + '&view=proxy', false)
                        .then(result => {
                            // console.log('loadExternalDataService', storageName, 'result', result);
                            $window.localStorage.setItem(storageName, JSON.stringify(result.data));
                            $window.localStorage.setItem(storageName + 'TimeStamp', Date.now().toString());
                            resolve(result.data);
                        })
                        .catch(error => reject(error));
                }
            });
        }
    }

    function getEdrpou(edrpou) {
        const url = `${getEdrpouResource}?edrpou=${encodeURIComponent(edrpou)}`;
        return http.get(url, true).then(result => result.data);
    }

    return {
        getCriterias: createLoadFunc(getCriteriasResource, 'criterias'),
        getOtherCriterias: createLoadFunc(getOtherCriteriasResource, 'otherCriterias'),
        getGuaranteeCriterias: createLoadFunc(getGuaranteeCriteriasResource, 'guaranteeCriterias'),
        getContractGuaranteeCriterias: createLoadFunc(getContractGuaranteeCriteriasResource, 'contractGuaranteeCriterias'),
        getLccCriterias: createLoadFunc(getLccCriteriasResource, 'lccCriterias'),
        classifierObjections16: createLoadFunc(classifierObjections16, 'classifierObjections16'),
        violation_amcu: createLoadFunc(violation_amcu, 'violation_amcu'),
        amcu: createLoadFunc(amcu, 'amcu'),
        requested_remedies_type: createLoadFunc(requested_remedies_type, 'requested_remedies_type'),
        local_origin_level: createLoadFunc(local_origin_level, 'local_origin_level'),
        amcu_24: createLoadFunc(amcu_24, 'amcu_24'),
        reporting_cause: createLoadFunc(reporting_cause, 'reporting_cause'),
        negotiation_quick_cause: createLoadFunc(negotiation_quick_cause, 'negotiation_quick_cause'),
        negotiation_cause: createLoadFunc(negotiation_cause, 'negotiation_cause'),
        uPlanList: createLoadFunc(uPlanList, 'uPlanList'),
        funderProgramsList: createLoadFunc(funderProgramsList, 'funderProgramsList'),
        uFacility: createLoadFunc(uFacility, 'uFacility'),
        contract_change_922: createLoadFunc(contract_change_922, 'contract_change_922'),
        contract_change_1178: createLoadFunc(contract_change_1178, 'contract_change_1178'),
        getEdrpou: getEdrpou
    }
});
